import { render, staticRenderFns } from "./checkboxMaketing.vue?vue&type=template&id=6700075e&scoped=true&"
import script from "./checkboxMaketing.vue?vue&type=script&lang=js&"
export * from "./checkboxMaketing.vue?vue&type=script&lang=js&"
import style0 from "./checkboxMaketing.vue?vue&type=style&index=0&id=6700075e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700075e",
  null
  
)

export default component.exports